<template>
  <div class="machineHitInvoice" ref="machineHitInvoice">
    <div>
      <div class="mfs-title" v-show="showTitle">
        <div>原始凭证</div>
        <div>{{ invoiceData.invoiceDate }}</div>
      </div>
      <div class="mfs-bx">
        <div class="TableTitle">
          <div>
            <font class="font-brown mr8">发票代码：</font>
            <font class="text-dark">{{ invoiceData.invoiceCode }}</font>
          </div>
          <div>
            <font class="font-brown mr8">发票号码：</font>
            <font class="text-dark">{{ invoiceData.invoiceNum }}</font>
          </div>
          <div>
            <font class="font-brown mr8">开票日期：</font>
            <font class="text-dark">{{ invoiceData.invoiceDate }}</font>
          </div>
          <div>
            <font class="font-brown mr8" v-html="'校&nbsp;&nbsp;验&nbsp;&nbsp;码：'"></font>
            <font class="text-dark">{{ invoiceData.checkCode }}</font>
          </div>
          <!-- <div>
            <font class="font-brown">机器编号：</font>
            <font class="font-black">{{ invoiceData.machineNo }}</font>
          </div> -->
        </div>
      </div>
      <div class="fapiao">
        <table class="fapiaoTable" cellspacing="0">
          <tr>
            <td colspan="1" class="shuli" v-html="'购<br /><br />买<br /><br />方'"></td>
            <td colspan="4" style="width: 50%">
              <table class="BuyTable" cellspacing="0">
                <tr>
                  <td class="BuyTableName" v-html="'名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：'">
                    
                  </td>
                  <td class="BuyTableContent">
                    {{ invoiceData.purchaserName }}
                  </td>
                </tr>
                <tr>
                  <td class="BuyTableName">纳税人识别号：</td>
                  <td class="BuyTableContent">
                    {{ invoiceData.purchaserRegisterNum }}
                  </td>
                </tr>
                <tr>
                  <td class="BuyTableName" v-html="'地址、&nbsp;&nbsp;&nbsp;电话：'"></td>
                  <td class="BuyTableContent">
                    {{ invoiceData.purchaserAddress }}
                  </td>
                </tr>
                <tr>
                  <td class="BuyTableName">开户行及账号：</td>
                  <td class="BuyTableContent">
                    {{ invoiceData.purchaserBank }}
                  </td>
                </tr>
              </table>
            </td>
            <td class="shuli2" v-html="'密<br /><br />码<br /><br />区'"></td>
            <td colspan="4">
              <table>
                <tr>
                  <td rowspan="3" class="TextArea"></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="GoodsTable">
          <el-table
            :data="commodityList"
            stripe
            style="width: 100%"
            height="350"
          >
            <!-- <el-table-column
              align="center"
              type="index"
              :index="$indexMethod"
              label=""
              width="0"
            ></el-table-column> -->
            <el-table-column prop="goodsName" label="货物或应税劳务、服务名称">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.commodityName }}</span>
                  <span
                    v-show="invoiceData.type == 0"
                    class="ml-12 font-gray"
                    >{{ scope.row.mainBusinessName }}</span
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="commodityType"
              width="120"
              label="规格型号"
            ></el-table-column>
            <el-table-column
              prop="commodityUnit"
              width="60"
              label="单位"
            ></el-table-column>
            <el-table-column
              prop="commodityNum"
              width="120"
              label="数量"
            ></el-table-column>
            <el-table-column prop="commodityPrice" width="120" label="单价">
              <template slot-scope="scope">
                <span>{{
                  scope.row.commodityPrice | valueFilter("amount")
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="commodityAmount" width="120" label="金额">
              <template slot-scope="scope">
                <span>{{
                  scope.row.commodityAmount | valueFilter("amount")
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="commodityTaxRate" width="120" label="税率">
            </el-table-column>
            <el-table-column prop="commodityTax" width="120" label="税额">
              <template slot-scope="scope">
                <span>{{
                  scope.row.commodityTax | valueFilter("amount")
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="GoodsTotal">
          <div colspan="5">
            <font class="font-brown">价税合计（大写）</font>
            <font class="font-black ml12">{{ invoiceData.amountInWords }}</font>
          </div>
          <div colspan="5">
            <font class="font-brown">（小写）</font>
            <font class="font-black ml12" v-show="invoiceData.totalAmount"
              >￥{{ invoiceData.totalAmount | valueFilter("amount") }}</font
            >
          </div>
        </div>
        <table class="fapiaoTable" cellspacing="0">
          <tr>
            <td colspan="1" class="shuli" v-html="'销<br /><br />售<br /><br />方'"></td>
            <td colspan="4" style="width: 50%">
              <table class="BuyTable" cellspacing="0">
                <tr>
                  <td class="BuyTableName" v-html="'名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：'">
                    
                  </td>
                  <td class="BuyTableContent">
                    {{ invoiceData.sellerName }}
                  </td>
                </tr>
                <tr>
                  <td class="BuyTableName">纳税人识别号：</td>
                  <td class="BuyTableContent">
                    {{ invoiceData.sellerRegisterNum }}
                  </td>
                </tr>
                <tr>
                  <td class="BuyTableName" v-html="'地址、&nbsp;&nbsp;&nbsp;电话：'"></td>
                  <td class="BuyTableContent">
                    {{ invoiceData.sellerAddress }}
                  </td>
                </tr>
                <tr>
                  <td class="BuyTableName">开户行及账号：</td>
                  <td class="BuyTableContent">
                    {{ invoiceData.sellerBank }}
                  </td>
                </tr>
              </table>
            </td>
            <td class="shuli2" v-html="'备<br /><br />注'"></td>
            <td colspan="4">
              <table>
                <tr>
                  <td rowspan="3" class="TextArea">
                    <span v-html="invoiceData.remarks" class="lh-24"></span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import { mapGetters } from "vuex";
export default {
  name: "machineHitInvoice",
  props: {
    data: Object,
    // date: {
    //   type: String
    // },
    // invokerInvoicesId: {
    //   type: Number
    // },
    list: Array,
    showTitle: { type: Boolean, default: true }
  },
  data() {
    return {
      invoiceData: this.data || { commodityList: [] },
      commodityList: this.list || [],
      tableIndex: null,
      url: ""
    };
  },
  created() {
    // this.getInvoicesInfo();
  },
  methods: {
    print() {
      //this.$print(this.$refs.machineHitInvoice)
    },
    mainBusinessNameSplit(name) {
      let arr = name.split("/");
      return arr;
    }
  },
  watch: {
    data(newVal) {
      this.invoiceData = newVal;
    },
    list(newVal) {
      this.commodityList = newVal;
    }
  }
};
</script>

<style lang="scss" scoped>
.machineHitInvoice {
  background: $--color-white;
  //padding: 24px;
  .mfs-title {
    width: 220px;
    margin: 0 auto 24px;
    text-align: center;
    > div:nth-child(1) {
      line-height: 50px;
      border-bottom: 2px solid $--color-text-stress;
      font-family: "PingFangSC,\5FAE\8F6F\96C5\9ED1";
      @include colorSize($--color-text-stress, 26px);
    }
    > div:nth-child(2) {
      color: #16222b;
      font-size: 12px;
      border-top: 2px solid $--color-text-stress;
      margin-top: 4px;
      padding-top: 8px;
    }
  }
  > div:nth-child(1) {
    //background:rgba(250,250,250,1);
    // padding: 24px;
  }
  .fapiao {
    border: 2px solid $--color-text-invoice;
    text-align: center;
    margin: 0 auto;
    @include colorSize($--color-text-invoice, $--font-size-small);
    .BuyTableContent {
      color: $--color-black;
    }
  }

  .fapiao input,
  textarea {
    width: 90%;
    border: 0;
  }

  .fapiaoTable {
    width: 100%;
  }

  .shuli {
    width: 20px;
    border-right: 2px solid $--color-text-invoice;
    padding: 20px;
    font-weight: $--font-weight-bold;
  }

  .shuli2 {
    width: 20px;
    padding: 15px;
    border-right: 2px solid $--color-text-invoice;
    border-left: 2px solid $--color-text-invoice;
    font-weight: $--font-weight-bold;
  }

  .BuyTable {
    width: 100%;
    margin: 13px;
    tr {
      line-height: 20px;
    }
  }

  .BuyTable input,
  textarea {
    border: 0;
    width: 100%;
  }

  .BuyTableName {
    padding: 8px 2px;
    width: 20%;
    text-align: left;
    font-weight: $--font-weight-bold;
  }

  .GoodsTable {
    width: 100%;
    border: 1px solid $--color-text-invoice;
    border-right: none;
    border-left: none;
    text-align: center;
    thead tr {
      td {
        padding: 13px 0 !important;
        border-bottom: 2px solid #944222;
        background: rgba(236, 247, 247, 1);
      }
    }
    tbody tr,
    tfoot tr {
      td {
        color: $--color-black;
      }
    }
    tbody {
      height: 250px;
      overflow-y: auto;
      tr:nth-child(odd) {
        td {
          background: rgba(251, 252, 254, 1);
        }
      }
      tr:nth-child(even) {
        td {
          background: rgba(240, 243, 245, 1);
        }
      }
    }
    & /deep/ {
      .el-table__header {
        th {
          border-right: 2px solid $--color-text-invoice;
        }
        th:nth-last-child(2) {
          border-right: none;
        }
      }
      .el-table__row {
        @include colorSize($--color-text-stress, $--font-size-small);
        td {
          border-top: 1px solid $--color-text-invoice;
          border-right: 2px solid $--color-text-invoice;
          border-bottom: 2px solid $--color-text-invoice;
        }
        td:last-child {
          border-right: none;
        }
      }
    }
  }

  .GoodsTable td {
    padding: 4px;
  }
  .GoodsTotal {
    @include flex;
    height: 50px;
    border-top: 2px solid $--color-text-invoice;
    border-bottom: 2px solid $--color-text-invoice;
    div {
      width: 50%;
      padding-left: 30px;
      line-height: 50px;
      color: $--color-text-invoice !important;
      text-align: left;
      //background:#944222;
    }
  }
  .BuyTableContent {
    width: 80%;
    text-align: left;
  }

  .TextArea {
    padding: 5px 2px 5px 15px;
    color: $--color-black;
  }

  .mfs-bx {
    margin: 0 auto;
    //  text-align: center;
    margin-bottom: 10px;
    // height: 100px;
    // margin-left: 41%;
    color: $--color-text-invoice;
  }
  .TableTitle {
    @include flex(row, space-between);
    font-size: $--font-size-small;
    // float: left;
    // margin-left: 70px;
    // display: flex;
    // justify-content: space-between;

    > div {
      width: 20%;
      text-align: left;
    }
    > div:last-child {
      //text-align: right;
    }
  }
}
</style>
